webpackJsonp([16],{

/***/ "./abound-scroll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hammerjs__ = __webpack_require__("../../node_modules/hammerjs/hammer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__("../../node_modules/ramda/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);



// if mobileSwipeEl is provided, will look at this element to trigger swiping left and right
window.aboundSectionScroll = function (leftEl, rightEl, sectionEls, itemsPerPaneDesktop, itemsPerPageMobile, mobileBreakpoint) {
    var mobileSwipeEl = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;

    var positiveOrZero = function positiveOrZero(x) {
        return x < 0 ? 0 : x;
    };

    var intOrZero = function intOrZero(x) {
        return !x ? 0 : parseInt(x, 10);
    };

    var setStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["curry"])(function (key, value, el) {
        el.style[key] = value;
        return el;
    });
    var getStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["curry"])(function (key, el) {
        return el.style[key];
    });

    var addClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["curry"])(function (className, el) {
        return el.classList.add(className);
    });
    var removeClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["curry"])(function (className, el) {
        return el.classList.remove(className);
    });

    var setLeft = setStyle('left');
    var getLeft = function getLeft(el) {
        return intOrZero(getStyle('left', el));
    };

    var getItemsPerPane = function getItemsPerPane() {
        return document.body.parentNode.clientWidth > mobileBreakpoint ? itemsPerPaneDesktop : itemsPerPageMobile;
    };

    var getItemPx = function getItemPx() {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["pathOr"])(0, [0, 'offsetWidth'], sectionEls);
    };
    var getScrollPx = function getScrollPx() {
        return getItemPx() * getItemsPerPane();
    };
    var getFullyRightPx = function getFullyRightPx() {
        return -1 * positiveOrZero(sectionEls.length - getItemsPerPane()) * getItemPx();
    }; // substract off one pane of items, because we're fully scrolled on the last pane (not beyond the last pane)

    var scrollLeft = function scrollLeft() {
        if (isScrolledFullyLeft()) return;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["map"])(function (el) {
            setLeft(getLeft(el) + getScrollPx() + 'px', el);
        }, sectionEls);

        updateArrowsEnabled();
    };

    var scrollRight = function scrollRight() {
        if (isScrolledFullyRight()) return;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["map"])(function (el) {
            setLeft(getLeft(el) - getScrollPx() + 'px', el);
        }, sectionEls);

        updateArrowsEnabled();
    };

    var scrollFullyLeft = function scrollFullyLeft() {
        if (isScrolledFullyLeft()) return;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["map"])(function (el) {
            setLeft(0, el);
        }, sectionEls);

        updateArrowsEnabled();
    };

    var isScrolledFullyLeft = function isScrolledFullyLeft() {
        return 0 === intOrZero(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["pathOr"])(0, [0, 'style', 'left'], sectionEls));
    };

    var isScrolledFullyRight = function isScrolledFullyRight() {
        return getFullyRightPx() >= intOrZero(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ramda__["pathOr"])(0, [0, 'style', 'left'], sectionEls));
    };

    var updateArrowsEnabled = function updateArrowsEnabled() {
        isScrolledFullyLeft() ? addClass('disabled', leftEl) : removeClass('disabled', leftEl);
        isScrolledFullyRight() ? addClass('disabled', rightEl) : removeClass('disabled', rightEl);
    };

    updateArrowsEnabled();
    leftEl && leftEl.addEventListener('click', scrollLeft);
    rightEl && rightEl.addEventListener('click', scrollRight);(leftEl || rightEl) && window.addEventListener('resize', scrollFullyLeft); // reset the scroll if the window changes, or else it will look weird
    if ((leftEl || rightEl) && mobileSwipeEl) {
        var hammer = new __WEBPACK_IMPORTED_MODULE_0_hammerjs___default.a(mobileSwipeEl, {});
        hammer.on('swipe', function (e) {
            if (e.direction === __WEBPACK_IMPORTED_MODULE_0_hammerjs___default.a.DIRECTION_LEFT) scrollRight();else if (e.direction === __WEBPACK_IMPORTED_MODULE_0_hammerjs___default.a.DIRECTION_RIGHT) scrollLeft();
        });
    }
};

/***/ })

},["./abound-scroll.js"]);


// WEBPACK FOOTER //
// scripts/abound-scroll.d075e11b60a6b8e95314.js